import { Row, Col } from "react-bootstrap";
import TeamMember from "./TeamMember";
import "./TeamMembersList.css";

function TeamMembersList({ teamMembers, language }) {
  return (
    <Col className="objectives-list">
      {teamMembers.map((element) => (
        <TeamMember
          key={element._id}
          id={element._id}
          name={element.name}
          objectives={element.objectives}
          language={language}
        />
      ))}
    </Col>
  );
}

export default TeamMembersList;
